import React from "react";
import { Tooltip as Base, TooltipProps } from "@chakra-ui/core";

const Tooltip = React.forwardRef<HTMLDivElement, TooltipProps>((props, ref) => {
  return <Base ref={ref} hasArrow {...props} />;
});

export default Tooltip;
